import React, { useState } from 'react'
import { ContentByTypeLanding } from '../../components'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { useNavigate } from 'react-router-dom'
import { contentUrl } from '../../helpers/url'
import { useAlert } from '../../hooks'
import { useSEO } from '../../components/seo-context'
import { ToolkitPrivateRoute } from '../../components/toolkit-private-route'

const PAGE_SIZE = 10

const crumbs = [{
  name: 'Most Popular'
}]

const MostPopularPage = () => {
  const [mostPopularContent, setMostPopularContent] = useState({ content: [] })

  const navigate = useNavigate()

  const { enqueueMsg } = useAlert()

  const [getMostPopularContent] = useEvent([{
    eventName: 'contentGetMostPopularContent',
    onSuccess: (payload) => {
      setMostPopularContent(payload)
    },
    onError: () => {
      enqueueMsg('Unable to get the most popular content', 'error')
    }
  }])

  const handleContentLike = (payload) => {
    const { locationId, hasRecommend, recommendCount } = payload
    setMostPopularContent(current => {
      const content = current.content.map(item => {
        if (item.locationId === locationId) {
          return { ...item, hasRecommend, recommendCount }
        }
        return item
      })
      return { ...current, content }
    })
  }

  const handleCardSelect = item => navigate(contentUrl(item, 'most-popular'))

  useEventsOnViewLoad(() => {
    if (!getMostPopularContent.hasBeenTriggered) {
      getMostPopularContent.trigger({
        size: PAGE_SIZE
      })
    }
  }, [getMostPopularContent])

  useSEO(
    getMostPopularContent.hasBeenTriggered && !getMostPopularContent.isWorking
  )

  return (
    <ContentByTypeLanding
      crumbs={crumbs}
      isLoading={getMostPopularContent.isWorking}
      pageSize={PAGE_SIZE}
      handleContentLike={handleContentLike}
      items={mostPopularContent.content}
      pageTitle='Most Popular'
      pageId='most-popular'
      handleCardSelect={handleCardSelect}
    />
  )
}

const Page = () => {
  return (
    <ToolkitPrivateRoute
      featureGuard='contentHub'
      publicOnlyForPublicTenant
      element={<MostPopularPage />}
    />
  )
}

export {
  Page as Component
}
